import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AeAuthService } from '@extranet/services/auth-service';
import { AeStorageService } from '@extranet/services/storage-service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class AeTokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly aeAuthService: AeAuthService,
    private readonly router: Router,
    private readonly aeStorageService: AeStorageService
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.aeAuthService.isLogged) {
      return next.handle(req);
    }
    const bearerToken = this.aeStorageService.getLocal('ae-login')?.token?.trim();
    if (!bearerToken) {
      return next.handle(req);
    }
    const newRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${bearerToken}`
      }
    });
    return next.handle(newRequest).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 && err.error.subCode === 'E_INVALID_TOKEN') {
            this.aeAuthService.logout();
            const data = {
              title: 'Session expirée',
              content: 'Votre session a expiré. Veuillez vous reconnecter.'
            };
            this.router.navigate(['/auth/information'], { state: data });
          }
        }
        return throwError(err);
      })
    );
  }
}
